<mat-sidenav-container class="example-container menuBar">
  <mat-sidenav mode="side" closed>Sidenav content</mat-sidenav>

  <!-- Dashboard (Doctor Only) -->
  <mat-sidenav-content *ngIf="userRole === 'Doctor'">
    <a [routerLink]="['dashboard']" class="nav-link menuMarging" mat-menu-item title="Dashboard" (click)="setActive('dashboard')">
      <img class="menuImg" [src]="isSectionActive('dashboard')
                   ? '/assets/img/DashboarhTabActive.png'
                   : '/assets/img/DashboardTabInactive.png'" alt="Dashboard" />
    </a>
  </mat-sidenav-content>

  <!-- Members -->
  <mat-sidenav-content>
    <a class="nav-link menuMarging" [routerLink]="['members']" mat-menu-item title="Members" (click)="setActive('members')">
      <img class="menuImg" [src]="isSectionActive('members')
                   ? '/assets/img/MembersTabActive.png'
                   : '/assets/img/MemberTabInactive.png'" alt="Members" />
    </a>
  </mat-sidenav-content>

  <!-- Teams -->
  <mat-sidenav-content>
    <a class="nav-link menuMarging" [routerLink]="['teams']" mat-menu-item title="Teams" (click)="setActive('teams')">
      <img class="menuImg" [src]="isSectionActive('teams')
                   ? '/assets/img/TeamTabActive.png'
                   : '/assets/img/TeamTabInactive.png'" alt="Teams" />
    </a>
  </mat-sidenav-content>

<!-- Calendar -->
<mat-sidenav-content>
  <a class="nav-link menuMarging"
     mat-menu-item
     [routerLink]="['/event-calender/add-event']"
     title="Calendar"
     (click)="setActive('calendar')">
    <img class="menuImg"
         [src]="isSectionActive('calendar')
                  ? '/assets/img/EventTabActive.png'
                  : '/assets/img/EventTabInactive.png'"
         alt="Calendar" />
  </a>
</mat-sidenav-content>

<!-- Quest & Mindfulness Creation -->
<mat-sidenav-content>
  <a class="nav-link menuMarging"
     mat-menu-item
     [routerLink]="['/quest-mindfulness-creation']"
     title="Quest & Mindfulness Creation"
     (click)="setActive('quest-mindfulness')">
    <img class="menuImg"
         [src]="isSectionActive('quest-mindfulness')
                  ? '/assets/img/QuestTabActive.png'
                  : '/assets/img/QuestTabInactive.png'"
         alt="Quest & Mindfulness Creation" />
  </a>
</mat-sidenav-content>

 


  <!-- Meal Plans (Nutritionist/Admin) -->
  <mat-sidenav-content *ngIf="userRole === 'Nutritionist' || userRole === 'Administrator'">
    <a class="nav-link menuMarging" [routerLink]="['meal-plans']" mat-menu-item title="Meal Plans" (click)="setActive('meal-plans')">
      <img class="menuImg" [src]="isSectionActive('meal-plans')
                   ? '/assets/img/MealPlanTabActive.png'
                   : '/assets/img/MealPlanTabInactive.png'" alt="Meal Plans" />
    </a>
  </mat-sidenav-content>

  <!-- Fitness Plan (Instructor/Admin) -->
  <mat-sidenav-content *ngIf="userRole === 'Fitness Instructor' || userRole === 'Administrator'">
    <a class="nav-link menuMarging" [routerLink]="['fitness-plan']" mat-menu-item title="Fitness Plan" (click)="setActive('fitness')">
      <img class="menuImg" [src]="isSectionActive('fitness')
                   ? '/assets/img/FitnessTabActive.png'
                   : '/assets/img/FitnessTabInactive.png'" alt="Fitness Plan" />
    </a>
  </mat-sidenav-content>

  <!-- Recipes (Nutritionist/Admin) -->
  <mat-sidenav-content *ngIf="userRole === 'Nutritionist' || userRole === 'Administrator'">
    <a class="nav-link menuMarging" [routerLink]="['/recipes']" mat-menu-item title="Recipes" (click)="setActive('recipes')">
      <img class="menuImg" [src]="isSectionActive('recipes')
                   ? '/assets/img/RecipeTabActive.png'
                   : '/assets/img/RecipeTabInactive.png'" alt="Recipes" />
    </a>

    <!-- Optional Submenu (Still commented out) -->
    <!--
    <div *ngIf="recipesExpanded" class="submenu">
      <a class="nav-link submenu-link" [routerLink]="['/recipes']" mat-menu-item (click)="setActive('recipes')">
        <span>All Recipes</span>
      </a>
      <a class="nav-link submenu-link" [routerLink]="['/add-recipe']" mat-menu-item (click)="setActive('recipes')">
        <span>Add Recipe</span>
      </a>
    </div>
    -->
  </mat-sidenav-content>

  <!-- Data Analysis (Nutritionist/Admin) -->
  <mat-sidenav-content *ngIf="userRole === 'Administrator'">
    <a
      class="nav-link menuMarging"
      [routerLink]="['/data-analysis']"
      mat-menu-item
      title="Data Analysis"
      (click)="setActive('data-analysis')"
    >
      <img
        class="menuImg"
        [src]="isSectionActive('data-analysis')
                 ? '/assets/img/DataAnalysisTabActive.png'
                 : '/assets/img/DataAnalysisTabInactive.png'"
        alt="Data Analysis"
      />
    </a>
  </mat-sidenav-content>
</mat-sidenav-container>